import { API_ROOT } from '@/api/config'
import Http from '@/classes/http/Http'
import { captchaHeaders } from '@/api/recaptcha/recaptchaApi'

export default {
  getLoginForm () {
    return Http.get({
      base_url: API_ROOT,
      url: 'account/login'
    })
  },
  loginUser (user) {
    return Http.post({
      base_url: API_ROOT,
      url: 'account/login',
      data: user
    })
  },
  logoutUser () {
    return Http._delete({
      base_url: API_ROOT,
      url: 'account/login'
    })
  },
  switchProfile (userId, profileType) {
    return Http.post({
      base_url: `${API_ROOT}/${profileType}`,
      url: `switch-profile/${userId}`
    })
  },
  resetProfile () {
    return Http._delete({
      base_url: API_ROOT,
      url: `account/reset-profile`
    })
  },
  getResetPasswordForm () {
    return Http.get({
      url: 'issue-password-reset/'
    })
  },
  postResetPasswordForm (request, captchaToken) {
    return Http.post({
      url: 'issue-password-reset/',
      data: request,
      headers: captchaHeaders(captchaToken)
    })
  },
  getResetPasswordSSNForm () {
    return Http.get({
      url: 'issue-password-reset-ssn/'
    })
  },
  postResetPasswordSSNForm (request, captchaToken) {
    return Http.post({
      url: 'issue-password-reset-ssn/',
      data: request,
      headers: captchaHeaders(captchaToken)
    })
  }
}
